import React, { useMemo } from "react";
import FilterMain from "./FilterMain";
import ListItems from "./ListItems";
import { stringifyObjectToRequestQuery } from "src/helpers";

import { QueryRequestProvider, useQueryRequest } from "./core/QueryRequestProvider";
import {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponseLoading,
} from "./core/QueryResponseProvider";

import ListItemLoader from "./ListItemLoader";

const Main = () => {
  const aopiResp = useQueryResponseData();
  const { refetch } = useQueryResponse();
  const { state, updateState } = useQueryRequest();
  const isLoading = useQueryResponseLoading();
  const data = useMemo(() => aopiResp, [aopiResp]);

  return (
    <div className="flex space-x-2">
      <div className="w-1/4 ">
        <div className="p-4 bg-orange-100 rounded-lg">
          <FilterMain
            onChange={(e: any) => {
              if (stringifyObjectToRequestQuery(state.filter) !== stringifyObjectToRequestQuery(e)) {
                updateState({
                  filter: e,
                });
              } else refetch();
            }}
          />
        </div>
      </div>
      <div className="w-3/4 ">
        {isLoading ? (
          <div className="grid grid-cols-2 gap-4">
            {" "}
            {[...new Array(5)].map((s: any) => {
              return <ListItemLoader />;
            })}
          </div>
        ) : (
          <ListItems data={data} />
        )}
      </div>
    </div>
  );
};

const ListMain = () => {
  return (
    <QueryRequestProvider>
      <QueryResponseProvider>
        <Main />
      </QueryResponseProvider>
    </QueryRequestProvider>
  );
};

export default ListMain;
